export class VideoSession {
  id: string
  videoUrl: string
  constructor(id: string, file: File) {
    this.id = id
    this.videoUrl = URL.createObjectURL(file)
  }
}
